import { useParams } from "react-router-dom";
import Header from "../component/menu/Header";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import { constants } from "../constant/constants";
import { useState, useEffect } from "react";
import BranchCreateEditComponent from "../component/restaurants/branches/BranchCreateEditComponent";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import { useLocation } from 'react-router-dom';

export default function BranchEdit() {
  const location = useLocation();
  const { user } = useUserStore();
  const params = useParams();
  const [currentRestaurantId, setCurrentRestaurantId] = useState("");
  const [currentBranchId, setCurrentBranchId] = useState("");
  const [branch, setBranch] = useState({
    parentRestaurantId: "",
    restaurantName: "",
    branchName: "",
    address: "",
    latitude: "",
    longitude: "",
    openTime: null,
    closeTime: null,
    status: "",
    openDays: [],
    vat: 0,
    serviceCharge: 0,
    customersPaymentOptions: [],
    adminsPaymentOptions: [],
    logo: "",
    offerImage: "",
    bannerImages: [],
  });
  const [isBranchFetched, setIsBranchFetched] = useState(false);

  // parse the query params
  const queryParams = new URLSearchParams(location.search);

  const [isAdmin, setIsAdmin] = useState(
    queryParams.has('isAdmin') ? 
    queryParams.get('isAdmin') :
    false
  );

  async function getBranchDetails(id) {
    if (id === null) return;
    const token = user.token.token;
    const { payload } = await ApiService.GET_BRANCH_WITH_ID(id, token);
    return payload;
  }

  // restaurant id
  useEffect(() => {
    if (Boolean(params.branchId)) {
      setCurrentRestaurantId(params.restaurantId);
      setCurrentBranchId(params.branchId);
      getBranchDetails(params.branchId).then((data) => {
        setBranch({
          ...data,
          restaurantId: params.restaurantId,
          branchId: params.branchId,
          vat: parseFloat(data?.vat) || 0,
          serviceCharge: parseFloat(data?.serviceCharge) || 0,
          bannerImages: [...data?.images],
          isVatIncluded: data.isVatIncluded ? 'YES' : 'NO',
          isSupplementaryDutyIncluded: data.isSupplementaryDutyIncluded ? 'YES' : 'NO',
          isServiceChargeIncluded: data.isServiceChargeIncluded ? 'YES' : 'NO'
        });
        setIsBranchFetched(true);
      });
    }
  }, [params]);

  console.log('__data___', branch.isVatIncluded)

  return (
    <section>
      <div className="flex flex-col bg-[#e5e7eb]">
        {/* {contextHolder} */}
        {/* <CustomLoader /> */}
        <Header title={""} menu={constants.SUPER_MENU.RESTAURANT} currentMenuKey={'T_51_S_51'}/>
        <div className="flex flex-row bg-prewhite">
          <SideMenu
            title={`McDonalds Food Chain`}
            menu={constants.SUPER_MENU.RESTAURANT}
          />
          <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
            <div className="flex flex-col w-full">
              <FormHeaderComponent
                title={`Branch Edit for ${branch.restaurantName}`}
                listRoute={`/restaurants/${currentRestaurantId}/details`}
                isShowRightButton={isAdmin ? false : true}
              />
              <div className="">
                {isBranchFetched && (
                  <BranchCreateEditComponent
                    key={'branch-edit'}
                    keyProp={'edit'}
                    records={{
                      _data: branch,
                      isAdmin: isAdmin
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
